export const toastConfiguration = (
  time = 3000,
): Record<string, string | number | boolean> => ({
  position: 'top-left',
  autoClose: time,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
});
